<template>
  <div :bordered='false'>
    <div class='table-page-search-wrapper'>
      <a-form layout='inline' @keyup.enter.native='searchQuery'>
        <a-row :gutter='24'>
          <a-col :md='8' :sm='12'>
            <a-form-item :label="$t(I18N_KEY + 'selectDate')">
              <a-range-picker
                v-model='queryParam.selectDate'
                format='YYYY-MM-DD' />
            </a-form-item>
          </a-col>
          <a-col :md='6' :sm='8'>
                  <span style='float: left;overflow: hidden;' class='table-page-search-submitButtons'>
                    <a-button type='primary' @click='searchQuery' icon='search'>{{ $t('search') }}</a-button>
                    <a-button type='primary' @click='searchReset' icon='reload' style='margin-left: 8px'>{{ $t('reset')
                      }}</a-button>
                    <a-button type='primary' @click="downLoadData()" icon='download'
                              style='margin-left: 8px'>{{ $t('exportFile')
                      }}</a-button>
                  </span>
          </a-col>
        </a-row>
      </a-form>

      <!-- 汇总数据表格 -->
      <a-card title="汇总数据" size="small" style="margin-bottom: 16px;">
        <a-table
          :columns="summaryColumns"
          :dataSource="summaryData"
          :pagination="false"
          :showHeader="true"
          size="small"
          bordered>
        </a-table>
      </a-card>

      <a-table
        ref='table'
        rowKey='id'
        size='middle'
        :columns='columns'
        :dataSource='dataSource'
        :pagination='false'
        :loading='loading'
        bordered
        @change='handleTableChange'>
      </a-table>
      <div style='margin-top: 15px; text-align: right;'>
        <v-pagination
          v-if='total'
          :page-num='form.pageNum'
          :page-size='form.pageSize'
          :total='total'
          @change='handleTableChange' />
      </div>
      <pending-modal ref='modalForm'></pending-modal>
    </div>
  </div>
</template>

<script>
import { filterObj } from '@/utils/util'
import { getOrderContractContract, getOrderContractContractSum } from '@/webpublicapi/order'
import Dict from '../modules/Dict'
import PendingModal from '../order/modules/PendingModal'
import vModal from '../modules/Modal'
import OrderDetail from '../order/OrderDetail'
import moment from 'moment'
import exportFile from '@/api/exportFile'

const I18N_KEY = 'order.'

export default {
  name: 'PendingOrderlist',
  components: {
    vModal,
    OrderDetail,
    Dict,
    PendingModal
  },
  data() {
    return {
      I18N_KEY,
      toggleSearchStatus: false,
      visible: false,
      orderId: undefined,
      custInfoId: undefined,
      form: {
        pageNum: 1,
        pageSize: 10
      },
      total: 0,
      dataSource: [],
      sum:{},
      // 查询条件
      queryParam: {
        'selectDate': [moment().startOf('day'), moment().startOf('day')]
      },
      loading: false,
      labelCol: {
        xs: { span: 8 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 16 },
        sm: { span: 19 }
      }
    }
  },
  computed: {
    // 汇总表格的列定义
    summaryColumns() {
      return [
        {
          title: '总金额汇总',
          dataIndex: 'totalPayment',
          align: 'left'
        },
        {
          title: '放款金额汇总',
          dataIndex: 'loanAmount',
          align: 'left'
        },
        {
          title: '利息汇总',
          dataIndex: 'interest',
          align: 'left'
        },
        {
          title: '税:5汇总',
          dataIndex: 'tax5',
          align: 'left'
        },
        {
          title: '税:23汇总',
          dataIndex: 'tax23',
          align: 'left'
        },
        {
          title: '特种营业税汇总',
          dataIndex: 'taxSpecial',
          align: 'left'
        },
        {
          title: '地方收入税汇总',
          dataIndex: 'taxLocal',
          align: 'left'
        }
      ]
    },
    summaryData() {
      return [
        {
          loanAmount: this.formatNumber(this.sum.loanamount),
          totalPayment: this.formatNumber(this.sum.totalpayment),
          interest: this.formatNumber(this.sum.interest),
          tax5: this.formatNumber(this.sum.tax5),
          tax23: this.formatNumber(this.sum.tax23),
          taxSpecial: this.formatNumber(this.sum.taxSpecial),
          taxLocal: this.formatNumber(this.sum.taxLocal)
        }
      ]
    },
    columns() {
      return [
        {
          title: this.$t(I18N_KEY + 'orderNo'),
          align: 'left',
          dataIndex: 'transno'
        },
        {
          title: this.$t(I18N_KEY + 'currentPeriod'),
          align: 'left',
          dataIndex: 'currentPeriod',
          customRender: (text) => 1
        },
        {
          title: this.$t(I18N_KEY + 'expiryDate'),
          align: 'left',
          dataIndex: 'paymentdate'
        },
        {
          title: this.$t(I18N_KEY + 'deadline'),
          align: 'left',
          dataIndex: 'payperiod'
        },
        {
          title: this.$t(I18N_KEY + 'startingTime'),
          align: 'left',
          dataIndex: 'startcontract'
        },
        {
          title: this.$t('customer.mobile'),
          align: 'left',
          dataIndex: 'custMobileNo'
        },
        {
          title: this.$t('customer.curp'),
          align: 'left',
          dataIndex: 'curp'
        },
        {
          title: this.$t('customer.firstName'),
          align: 'left',
          dataIndex: 'customer_firstname'
        },
        {
          title: this.$t('customer.residentialAddress'),
          align: 'left',
          dataIndex: 'residentialAddress',
          customRender: (text) => {
            if (!text) return ''
            if (text.length <= 15) return text
            return text.substring(0, 15) + '*****'
          }
        },
        {
          title: this.$t(I18N_KEY + 'totalAmount'),
          align: 'left',
          dataIndex: 'totalpayment',
          customRender: (text) => {
            return this.formatNumber(text)
          }
        },
        {
          title: this.$t(I18N_KEY + 'loanAmount'),
          align: 'left',
          dataIndex: 'loanamount',
          customRender: (text) => {
            return this.formatNumber(text)
          }
        },
        {
          title: this.$t(I18N_KEY + 'interest'),
          align: 'left',
          dataIndex: 'interest',
          customRender: (text) => {
            return this.formatNumber(text)
          }
        },
        {
          title: this.$t(I18N_KEY + 'settleStatus'),
          align: 'left',
          dataIndex: 'repaymentStats',
          customRender: (text) => {
            return text == 1 ? '还款' : '未还款'
          }
        },
        {
          title: this.$t(I18N_KEY + 'repayment'),
          align: 'left',
          dataIndex: 'loanCount',
          customRender: (text) => {
            return text == 1 ? '首贷' : '复贷'
          }
        },
        {
          title: this.$t(I18N_KEY + 'tax5'),
          align: 'left',
          dataIndex: 'tax5',
          customRender: (text) => {
            return this.formatNumber(text)
          }
        },
        {
          title: this.$t(I18N_KEY + 'tax23'),
          align: 'left',
          dataIndex: 'tax23',
          customRender: (text) => {
            return this.formatNumber(text)
          }
        },
        {
          title: this.$t(I18N_KEY + 'taxSpecial'),
          align: 'left',
          dataIndex: 'taxSpecial',
          customRender: (text) => {
            return this.formatNumber(text)
          }
        },
        {
          title: this.$t(I18N_KEY + 'taxLocal'),
          align: 'left',
          dataIndex: 'taxLocal',
          customRender: (text) => {
            return this.formatNumber(text)
          }
        }
      ]
    }
  },
  created() {
    this.loadData(1)
  },
  methods: {
    formatNumber(value) {
      if (value === undefined || value === null) return '0'
      const num = Number(value)
      // 使用更严格的整数判断
      if (Number.isInteger(num) || num.toString().split('.')[1] === '0') {
        return num.toLocaleString('en-US')
      } else {
        return num.toLocaleString('en-US', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        })
      }
    },
    handleToggleSearch() {
      this.toggleSearchStatus = !this.toggleSearchStatus
    },
    searchQuery() {
      this.loadData(1)
    },
    transformStringToLow(str) {
      return str && str.toLocaleLowerCase()
    },
    loadData(arg) {
      // 加载数据 若传入参数1则加载第一页的内容
      if (arg === 1) {
        this.form.pageNum = 1
      }
      this.loading = true
      var params = this.getQueryParams()// 查询条件
      params.type = 0
      getOrderContractContract(params).then((res) => {
        if (res.code === 1000) {
          this.total = res.data.total
          this.dataSource = res.data.list
        } else {
          this.total = 0
          this.dataSource = []
          this.$message.error(res.msg)
        }
        this.loading = false
      }).catch(e => {
        this.loading = false
        this.$message.error(e.message)
      })
      getOrderContractContractSum(params).then((res) => {
        if (res.code === 1000) {
          this.sum = res.data
        } else {
          this.sum = {}
          this.$message.error(res.msg)
        }
        this.loading = false
      }).catch(e => {
        this.loading = false
        this.$message.error(e.message)
      })
    },
    downLoadData() {
      var params = this.getQueryParams()// 查询条件
      console.log('下载参数',params)
      const file = {
        fileUrl: '/api/web/webpublic/orderContract/contractExcel?startDate='
          + params.startDate + '&endDate=' + params.endDate + '&type=0' ,
        fileName:   "contract" + params.startDate  + params.endDate +'.xlsx',
      }
      this.loading = true;
      exportFile(file).catch(e => {
        this.$message.error(e.message);
      }).finally(() => {
        this.loading = false;
      })
    },
    transformTime(time) {
      return moment(time).format('YYYY-MM-DD')
    },
    getQueryParams() {
      var selectDate  = this.queryParam.selectDate
      console.log("params"+selectDate)
      var param = Object.assign({}, this.queryParam)
      param.pageNum = this.form.pageNum
      param.pageSize = this.form.pageSize
      param.startDate =  selectDate && this.transformTime(selectDate[0])
      param.endDate = selectDate && this.transformTime(selectDate[1])
      return filterObj(param)
    },
    handleTableChange(pageNum, pageSize) {
      this.form.pageNum = pageNum
      this.form.pageSize = pageSize
      this.loadData()
    },
    // 重置字典类型搜索框的内容
    searchReset() {
      var that = this
      that.queryParam.selectDate = ''
      that.queryParam.startDate = ''
      that.queryParam.endDate = ''
    },
    changeModal(visible) {
      this.visible = visible
    },
    handleDetail(row) {
      this.orderId = row.id
      this.custInfoId = row.custInfoId
      this.changeModal(true)
    }
  }
}
</script>
<style lang='less' scoped>
@import "~@/assets/less/common.less";
</style>
